import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';

import i18n from '../../i18n';
import Loading from '../common/Loading';
import Utils from '../../utils/utils';

const ExchangeRatingOptimalModal = ({ optimalPrice, show, closeModal }) => (
    <Modal dialogClassName="exchange-rating-optimal-modal" show={show} onHide={closeModal}>
        <Modal.Header closeButton>
            <Modal.Title>{i18n.t('exchange:ratings-optimal-modal.title')}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
            {optimalPrice ? (
                <p
                    dangerouslySetInnerHTML={{
                        __html: i18n.t('exchange:ratings-optimal-modal.content', {
                            price: `<b>${optimalPrice}</b>`
                        })
                    }}
                />
            ) : (
                <Loading />
            )}
            <img src={`${Utils.getAssetsDomain()}/images/website/common/optimal-he.svg`} alt="" />
        </Modal.Body>

        <Modal.Footer>
            <a href={i18n.t('url:dashboard')} className="btn btn-white">
                {i18n.t('exchange:ratings-optimal-modal.action.dashboard')}
            </a>
            <a href={i18n.t('url:subscription_payment')} className="btn btn-primary">
                {i18n.t('subscription:subscribe')}
            </a>
        </Modal.Footer>
    </Modal>
);

ExchangeRatingOptimalModal.propTypes = {
    optimalPrice: PropTypes.string,
    show: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired
};

export default ExchangeRatingOptimalModal;
